<template>
  <v-container>
    <v-row>
      <v-spacer />
      <v-col  xl="4" lg="6" md="7" sm="8" cols="12">
        <AuthOptions v-if="!user.loggedIn" userType="STUDENT" />

        <v-card outlined v-else-if="user.data.userType=='LECTURER'">
          <v-card-title>
            This is a student invitation...
          </v-card-title>
          <v-card-text>
            As a lecturer you cannot accept a student invitation. Go to the dashboard to run your tutorial.
            <v-btn depressed class="mt-3" router :to='{ name: "LecturerDashboard" }'>
              Open the Dashboard
            </v-btn>
          </v-card-text>
        </v-card>

        <v-card outlined v-else-if="user.data.userType=='STUDENT'" class="text-center">
          <v-card-title>
            Accepting the invitation...
          </v-card-title>
          <v-card-text class="pb-10">
            <v-progress-circular :size="100" :width="10" color="grey darken--4" indeterminate />
          </v-card-text>
        </v-card>

      </v-col>
      <v-spacer />
    </v-row>
  </v-container>
</template>

<script>
import firebase from '@/firebase.config'
import { mapGetters } from 'vuex'
import AuthOptions from '@/components/auth/AuthOptions'

export default {
  name: "Invite",
  components: { AuthOptions },
  data: function() {
    return {
      acceptingInvite: false
    }
  },
  computed: {
    ...mapGetters({
      user: "user"
    }),
  },
  methods:{
    async acceptInvite() {
      // acceptInvite should be allowed to happen only once
      if (!this.acceptingInvite) {
        this.acceptingInvite = true

        // Retrieve the teachingSession
        const teachingSessionSnapshot = await firebase.firestore().collectionGroup('teachingSessions').where('inviteCode', '==', this.$route.params.id).get()
        const teachingSessionRef = teachingSessionSnapshot.docs[0].ref
        // Check if there is an existing attempt by this user. They can only accept an invite once
        const attemptQuery = await firebase.firestore().collectionGroup('attempts').where("studentId", "==", this.user.id).where("parentPath", "==", teachingSessionRef.path).get()
        if (attemptQuery.empty) {
          // Use its reference to teachingSession to add an attempt by this student
          const attemptData = {
            studentId: this.user.id,
            eventLog: [{
              timestamp: firebase.firestore.Timestamp.now(),
              creator: 'STUDENT',
              message: 'Accepted invitation'
            },],
            screenshareStatus: null,
            currentCssSelector: null,
            parentPath: teachingSessionRef.path
          }
          await this.$store.dispatch('addAttempt', attemptData)

          // Report to GA
          firebase.analytics().logEvent('accept_invite')
        }
        this.$router.push({ name: 'StudentDashboard'})
      }
    }
  },
  async created() {
    // Report to GA
    firebase.analytics().logEvent('open_invite')

    // if the user is already logged in and is a student
    if (this.user.loggedIn && this.user.data.userType=='STUDENT') {
      // Accept the invititation immediately
      await this.acceptInvite()
    }
  },
  watch: {
    user: {
     handler: async function(value) {
        // If the user is not logged in when the page is loaded,
        // then accept the invite when they authenticate if they are a student
        if (value.loggedIn && this.user.data.userType=='STUDENT') {
          await this.acceptInvite()
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
</style>
